import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "filter-fieldset filterAndButtons" }
const _hoisted_4 = { class: "filter-legend" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = {
  key: 1,
  class: ""
}
const _hoisted_7 = { class: "inputWrap noMarginLeft" }
const _hoisted_8 = {
  key: 2,
  class: ""
}
const _hoisted_9 = {
  key: 3,
  class: ""
}
const _hoisted_10 = {
  key: 4,
  class: ""
}
const _hoisted_11 = {
  key: 5,
  class: ""
}
const _hoisted_12 = {
  key: 6,
  class: ""
}
const _hoisted_13 = {
  key: 7,
  class: ""
}
const _hoisted_14 = {
  key: 8,
  class: "inputWrap"
}
const _hoisted_15 = {
  key: 9,
  class: "inputWrap"
}
const _hoisted_16 = {
  key: 10,
  class: "inputWrap noMarginLeft"
}
const _hoisted_17 = {
  key: 11,
  class: "inputWrap"
}
const _hoisted_18 = {
  key: 12,
  class: "inputWrap"
}
const _hoisted_19 = {
  key: 13,
  class: "inputWrap"
}
const _hoisted_20 = {
  key: 14,
  class: "inputWrap"
}
const _hoisted_21 = {
  key: 15,
  class: "inputWrap"
}
const _hoisted_22 = {
  key: 16,
  class: "inputWrap"
}
const _hoisted_23 = {
  key: 17,
  class: "dateInputWrap"
}
const _hoisted_24 = {
  key: 18,
  class: "dateInputWrap"
}
const _hoisted_25 = {
  key: 19,
  class: "dateInputWrap"
}
const _hoisted_26 = {
  key: 20,
  class: "dateInputWrap"
}
const _hoisted_27 = {
  key: 21,
  class: "dateInputWrap"
}
const _hoisted_28 = {
  key: 22,
  class: "dateInputWrap"
}
const _hoisted_29 = {
  key: 23,
  class: "dateInputWrap"
}
const _hoisted_30 = {
  key: 24,
  class: "dateInputWrap"
}
const _hoisted_31 = {
  key: 25,
  class: "dateInputWrap"
}
const _hoisted_32 = {
  key: 26,
  class: "dateInputWrap"
}
const _hoisted_33 = {
  key: 27,
  class: "dateInputWrap"
}
const _hoisted_34 = {
  key: 28,
  class: "dateInputWrap"
}
const _hoisted_35 = {
  key: 30,
  class: ""
}
const _hoisted_36 = {
  key: 31,
  class: ""
}
const _hoisted_37 = {
  key: 0,
  class: "inputWrap noMarginLeft"
}
const _hoisted_38 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DropDownMultiple = _resolveComponent("DropDownMultiple")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      class: _normalizeClass({ invisible: _ctx.hideHeader })
    }, _toDisplayString(_ctx.$t('title.search')), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", _hoisted_3, [
        _createElementVNode("legend", _hoisted_4, _toDisplayString(_ctx.$t('title.search')), 1),
        (this.comparisonListFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_DropDown, {
                display: _ctx.displayType,
                label: _ctx.$t('label.fournisseur.dropdown.montantttc'),
                list: _ctx.comparisonListFacture,
                selectedItem: _ctx.filter.comparisonFacture,
                class: "width-250px",
                onSelect: _ctx.selectComparisonFacture
              }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"])
            ]))
          : _createCommentVNode("", true),
        (this.comparisonListFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_NumberInput, {
                  modelValue: _ctx.filterMontant,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterMontant) = $event)),
                  class: _normalizeClass([_ctx.filterMontant !== '' ? 'montant' : '', "filterInput"]),
                  label: _ctx.$t('label.fournisseur.input.montant')
                }, null, 8, ["modelValue", "class", "label"])
              ])
            ]))
          : _createCommentVNode("", true),
        (this.siteListTotal !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_DropDownMultiple, {
                checkboxDisplay: this.siteCheckboxDisplay,
                "drop-down-bigger": true,
                inputDisplay: this.filterSiteDisplay,
                isChecked: this.isCheckedSite,
                label: _ctx.$t('label.bySite'),
                list: _ctx.siteList,
                listTotal: _ctx.siteListTotal,
                search: _ctx.searchSite,
                selectedItems: _ctx.filter.siteList,
                withSearch: true,
                class: "selectSite",
                onAdd: _ctx.addSelectSite,
                onMultipleSelectSearch: this.multipleSelectSearchSite,
                onRemove: _ctx.removeSelectSite,
                onToggleSelectAll: _cache[1] || (_cache[1] = ($event: any) => (this.toggleSelectAll('site')))
              }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "listTotal", "search", "selectedItems", "onAdd", "onMultipleSelectSearch", "onRemove"])
            ]))
          : _createCommentVNode("", true),
        (this.typeInterventionList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_DropDown, {
                display: _ctx.displayType,
                label: _ctx.$t('facture.suivi.dropdown.type.label'),
                list: _ctx.typeInterventionList,
                selectedItem: _ctx.filter.typeIntervention?.libelle,
                class: "width-250px",
                onSelect: _ctx.selectType
              }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"])
            ]))
          : _createCommentVNode("", true),
        (this.filter.statusList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_DropDownMultiple, {
                checkboxDisplay: this.statusCheckboxDisplay,
                inputDisplay: this.filterStatusDisplay,
                isChecked: this.isCheckedStatus,
                label: _ctx.$t('label.byStatus'),
                list: _ctx.statusList,
                listTotal: _ctx.statusList,
                selectedItems: _ctx.filter.statusList,
                onAdd: _ctx.addSelectStatus,
                onRemove: _ctx.removeSelectStatus,
                onToggleSelectAll: _cache[2] || (_cache[2] = ($event: any) => (this.toggleSelectAll('status')))
              }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "listTotal", "selectedItems", "onAdd", "onRemove"])
            ]))
          : _createCommentVNode("", true),
        (this.filter.groupeList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_DropDownMultiple, {
                checkboxDisplay: this.groupeCheckboxDisplay,
                "drop-down-bigger": true,
                inputDisplay: this.filterGroupeDisplay,
                isChecked: this.isCheckedGroupe,
                label: _ctx.$t('label.byGroupe'),
                list: _ctx.groupeList,
                listTotal: _ctx.groupeList,
                selectedItems: _ctx.filter.groupeList,
                disabled: _ctx.isGroupeDisabled,
                onAdd: _ctx.addSelectGroupe,
                onRemove: _ctx.removeSelectGroupe,
                onToggleSelectAll: _cache[3] || (_cache[3] = ($event: any) => (this.toggleSelectAll('groupe')))
              }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "listTotal", "selectedItems", "disabled", "onAdd", "onRemove"])
            ]))
          : _createCommentVNode("", true),
        (this.filter.sousGroupeList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_DropDownMultiple, {
                checkboxDisplay: this.sousGroupeCheckboxDisplay,
                "drop-down-bigger": true,
                inputDisplay: this.filterSousGroupeDisplay,
                isChecked: this.isCheckedSousGroupe,
                label: _ctx.$t('label.bySousGroupe'),
                list: _ctx.sousGroupeList,
                "list-total": _ctx.sousGroupeList,
                selectedItems: _ctx.filter.sousGroupeList,
                disabled: _ctx.isSousGroupeDisabled,
                onAdd: _ctx.addSelectSousGroupe,
                onRemove: _ctx.removeSelectSousGroupe,
                onToggleSelectAll: _cache[4] || (_cache[4] = ($event: any) => (this.toggleSelectAll('sousgroupe')))
              }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "list-total", "selectedItems", "disabled", "onAdd", "onRemove"])
            ]))
          : _createCommentVNode("", true),
        (this.equipementList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_DropDownMultiple, {
                checkboxDisplay: this.equipementCheckboxDisplay,
                "drop-down-bigger": true,
                inputDisplay: this.filterEquipementDisplay,
                isChecked: this.isCheckedEquipement,
                label: _ctx.$t('label.byEquipement'),
                list: _ctx.equipementList,
                selectedItems: _ctx.filter.equipementList,
                disabled: _ctx.isEquipementDisabled,
                onAdd: _ctx.addSelectEquipement,
                onRemove: _ctx.removeSelectEquipement,
                onToggleSelectAll: _cache[5] || (_cache[5] = ($event: any) => (this.toggleSelectAll('equipement')))
              }, null, 8, ["checkboxDisplay", "inputDisplay", "isChecked", "label", "list", "selectedItems", "disabled", "onAdd", "onRemove"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.interventionId !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_NumberInput, {
                modelValue: _ctx.filterInterventionId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterInterventionId) = $event)),
                label: _ctx.$t('label.numIntervention'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.demandeInterventionId !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_NumberInput, {
                modelValue: _ctx.filterDemandeInterventionId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterDemandeInterventionId) = $event)),
                label: _ctx.$t('label.numDemandeIntervention'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.demandeDevisId !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_NumberInput, {
                modelValue: _ctx.filterDemandeDevisId,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterDemandeDevisId) = $event)),
                label: _ctx.$t('label.numDemandeDevis'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.numFactures !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterNumFactures,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterNumFactures) = $event)),
                label: _ctx.$t('label.numFactures'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.devisId !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterDevisId,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterDevisId) = $event)),
                label: _ctx.$t('label.numDevis'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.numero !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterNumero,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterNumero) = $event)),
                label: _ctx.$t('label.numero'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.numeroFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterNumero,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterNumero) = $event)),
                label: _ctx.$t('label.filtre.facture'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.libelleDoe !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterLibelleDoe,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterLibelleDoe) = $event)),
                label: _ctx.$t('label.filtre.libelleDoe'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.localisationList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_TextInput, {
                modelValue: _ctx.filterLocalisation,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filterLocalisation) = $event)),
                label: _ctx.$t('label.byLocalisation'),
                class: "filterInput"
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.predictedDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_DatePicker, {
                dateMax: _ctx.filter.predictedDateTo,
                dateValue: _ctx.filter.predictedDateFrom,
                label: _ctx.$t('label.predictedDateFrom'),
                onSetDate: this.setFilterPredictedDateFrom
              }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.predictedDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_DatePicker, {
                dateMin: _ctx.filter.predictedDateFrom,
                dateValue: _ctx.filter.predictedDateTo,
                label: _ctx.$t('label.predictedDateTo'),
                onSetDate: this.setFilterPredictedDateTo
              }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.createdDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_DatePicker, {
                dateMax: _ctx.filter.createdDateTo,
                dateValue: _ctx.filter.createdDateFrom,
                label: _ctx.$t('label.createdDateFrom'),
                onSetDate: this.setFilterCreatedDateFrom
              }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.createdDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_DatePicker, {
                dateMin: _ctx.filter.createdDateFrom,
                dateValue: _ctx.filter.createdDateTo,
                label: _ctx.$t('label.createdDateTo'),
                onSetDate: this.setFilterCreatedDateTo
              }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.factureDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_DatePicker, {
                dateMax: _ctx.filter.factureDateTo,
                dateValue: _ctx.filter.createdDateFrom,
                label: _ctx.$t('label.factureDateFrom'),
                onSetDate: this.setFilterCreatedDateFrom
              }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.factureDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_DatePicker, {
                dateMin: _ctx.filter.factureDateFrom,
                dateValue: _ctx.filter.createdDateTo,
                label: _ctx.$t('label.factureDateTo'),
                onSetDate: this.setFilterCreatedDateTo
              }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.documentDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_DatePicker, {
                dateMax: _ctx.filter.documentDateTo,
                dateValue: _ctx.filter.documentDateFrom,
                label: _ctx.$t('label.documentDateFrom'),
                onSetDate: this.setFilterDocumentDateFrom
              }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.documentDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_DatePicker, {
                dateMin: _ctx.filter.documentDateFrom,
                dateValue: _ctx.filter.documentDateTo,
                label: _ctx.$t('label.documentDateTo'),
                onSetDate: this.setFilterDocumentDateTo
              }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.devisPubliDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_DatePicker, {
                dateMax: _ctx.filter.devisPubliDateTo,
                dateValue: _ctx.filter.devisPubliDateFrom,
                label: _ctx.$t('label.devisPubliDateFrom'),
                onSetDate: this.setFilterDevisPubliDateFrom
              }, null, 8, ["dateMax", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.devisPubliDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_component_DatePicker, {
                dateMin: _ctx.filter.devisPubliDateFrom,
                dateValue: _ctx.filter.devisPubliDateTo,
                label: _ctx.$t('label.devisPubliDateTo'),
                onSetDate: this.setFilterDevisPubliDateTo
              }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.from !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_component_DatePicker, {
                "date-max": _ctx.filter.to,
                dateValue: _ctx.filter.from,
                label: _ctx.$t('label.from'),
                onSetDate: this.setFilterCreatedDateFrom
              }, null, 8, ["date-max", "dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.to !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createVNode(_component_DatePicker, {
                dateValue: _ctx.filter.to,
                label: _ctx.$t('label.to'),
                onSetDate: this.setFilterCreatedDateTo
              }, null, 8, ["dateValue", "label", "onSetDate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.isMine !== undefined)
          ? (_openBlock(), _createBlock(_component_CheckBox, {
              key: 29,
              checked: _ctx.filter.isMine,
              label: _ctx.$t('checkbox.onlyMyRequest'),
              onClickCheck: _ctx.toggleCheckMine
            }, null, 8, ["checked", "label", "onClickCheck"]))
          : _createCommentVNode("", true),
        (this.comparisonList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(_component_DropDown, {
                display: _ctx.displayType,
                label: _ctx.$t('facture.suivi.dropdown.montant.label'),
                list: _ctx.comparisonList,
                selectedItem: _ctx.filter.comparison,
                class: "width-250px",
                onSelect: _ctx.selectComparison
              }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"])
            ]))
          : _createCommentVNode("", true),
        (
                        this.comparisonList !== undefined &&
                        this.filter.comparison !== this.$t('facture.suivi.dropdown.novalue')
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              (_ctx.filter.interventionId !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_NumberInput, {
                      modelValue: _ctx.filterMontant,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filterMontant) = $event)),
                      class: _normalizeClass([_ctx.filterMontant !== '' ? 'montant' : '', "filterInput"]),
                      label: _ctx.$t('facture.suivi.input.montant')
                    }, null, 8, ["modelValue", "class", "label"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.getClassByCritere())
          }, [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_ButtonWhite, {
                onClick: _ctx.clearFilter,
                text: _ctx.$t('button.clear'),
                class: "clearBtn"
              }, null, 8, ["onClick", "text"]),
              _createVNode(_component_ButtonBlue, {
                disabled: _ctx.disabled && _ctx.hideButton === undefined,
                onClick: _ctx.search,
                text: _ctx.$t('button.search'),
                class: "searchBtn"
              }, null, 8, ["disabled", "onClick", "text"])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}